export default __webpack_public_path__ + "static/media/HOME.7afa7a9e.jpg";